(function () {
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function formatMoney(cents, currency) {
    try {
      return (cents / 100).toLocaleString('tr-TR', {
        style: 'currency',
        currency: currency || 'TRY'
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' TL';
    }
  }

  function openCartDrawer() {
    if (window.OniviasCart && typeof window.OniviasCart.open === 'function') {
      return window.OniviasCart.open();
    }
    var drawer = qs('[data-cart-drawer]');
    var overlay = qs('[data-cart-drawer-overlay]');
    if (!drawer || drawer.dataset.enabled !== 'true') return false;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    if (typeof window.oniviasLockBodyScroll === 'function') window.oniviasLockBodyScroll(true);
    else document.body.style.overflow = 'hidden';
    return true;
  }

  function updateCartCount(count) {
    if (window.OniviasCart && typeof window.OniviasCart.updateCount === 'function') {
      window.OniviasCart.updateCount(count);
      return;
    }
    qsa('.site-header__cart-count').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function rebuildCartDrawer(cart) {
    if (window.OniviasCart && typeof window.OniviasCart.rebuild === 'function') {
      window.OniviasCart.rebuild(cart);
    }
  }

  function initGallery(root) {
    var gallery = qs('[data-pdp-gallery]', root);
    if (!gallery) return { goTo: function () {}, goToMediaId: function () {} };

    var slides = qsa('[data-main-slide]', gallery);
    var thumbs = qsa('[data-thumb]', gallery);
    var dots = qsa('[data-dot]', gallery);
    var viewport = qs('[data-zoom-root]', gallery) || qs('[data-pdp-main]', gallery);
    var mobileMq = window.matchMedia('(max-width: 989px)');
    var index = 0;
    var scrolling = false;

    function isMobile() {
      return mobileMq.matches;
    }

    function syncUi() {
      var activeId = slides[index] && slides[index].getAttribute('data-media-id');
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
      thumbs.forEach(function (thumb) {
        var on = String(thumb.getAttribute('data-media-id')) === String(activeId);
        thumb.classList.toggle('is-active', on);
        if (on) {
          thumb.setAttribute('aria-current', 'true');
          if (!isMobile()) {
            thumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
      });
    }

    function goTo(i, fromScroll) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      syncUi();

      if (isMobile() && viewport && !fromScroll) {
        scrolling = true;
        var left = Math.round(index * viewport.clientWidth);
        viewport.scrollTo({ left: left, behavior: 'smooth' });
        window.setTimeout(function () {
          scrolling = false;
        }, 350);
      }
    }

    function goToMediaId(mediaId) {
      if (!mediaId) return;
      var found = slides.findIndex(function (slide) {
        return String(slide.getAttribute('data-media-id')) === String(mediaId);
      });
      if (found >= 0) goTo(found);
    }

    var prev = qs('[data-main-prev]', gallery);
    var next = qs('[data-main-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(Number(thumb.getAttribute('data-index')) || 0);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-index')) || 0);
      });
    });

    var thumbsList = qs('[data-thumbs-list]', gallery);
    var thumbsPrev = qs('[data-thumbs-prev]', gallery);
    var thumbsNext = qs('[data-thumbs-next]', gallery);
    if (thumbsList && thumbsPrev && thumbsNext) {
      thumbsPrev.addEventListener('click', function () {
        thumbsList.scrollBy({ top: -160, behavior: 'smooth' });
      });
      thumbsNext.addEventListener('click', function () {
        thumbsList.scrollBy({ top: 160, behavior: 'smooth' });
      });
    }

    /* Mobile: native horizontal scroll-snap */
    if (viewport && slides.length > 1) {
      var scrollTimer;
      viewport.addEventListener(
        'scroll',
        function () {
          if (!isMobile() || scrolling) return;
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function () {
            var width = viewport.clientWidth || 1;
            var nextIndex = Math.round(viewport.scrollLeft / width);
            nextIndex = Math.max(0, Math.min(slides.length - 1, nextIndex));
            if (nextIndex !== index) {
              index = nextIndex;
              syncUi();
            }
          }, 40);
        },
        { passive: true }
      );

    }

    /* Hover zoom (desktop only) */
    var zoomRoot = qs('[data-zoom-root]', gallery);
    var lens = qs('[data-zoom-lens]', gallery);
    if (zoomRoot && lens && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      function activeImg() {
        var slide = slides[index];
        return slide ? qs('[data-main-image]', slide) : null;
      }

      zoomRoot.addEventListener('mouseenter', function () {
        var img = activeImg();
        if (!img || !img.getAttribute('data-zoom-image')) return;
        lens.hidden = false;
        lens.classList.add('is-visible');
        lens.style.backgroundImage = 'url("' + img.getAttribute('data-zoom-image') + '")';
      });
      zoomRoot.addEventListener('mouseleave', function () {
        lens.classList.remove('is-visible');
        lens.hidden = true;
      });
      zoomRoot.addEventListener('mousemove', function (e) {
        var img = activeImg();
        if (!img || lens.hidden) return;
        var rect = zoomRoot.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        lens.style.backgroundSize = '220%';
        lens.style.backgroundPosition = x + '% ' + y + '%';
      });
    }

    /* Lightbox gallery */
    var lightbox = qs('[data-pdp-lightbox]', root);
    var lightboxImg = qs('[data-lightbox-img]', root);
    var lightboxCounter = qs('[data-lightbox-counter]', root);
    var lightboxThumbs = qsa('[data-lightbox-thumb]', root);
    var lightboxOpen = false;
    var lightboxIndex = 0;

    function mediaSrc(i) {
      var slide = slides[i];
      if (!slide) return '';
      var img = qs('[data-main-image]', slide);
      if (!img) return '';
      return img.getAttribute('data-zoom-image') || img.currentSrc || img.src || '';
    }

    function mediaAlt(i) {
      var slide = slides[i];
      if (!slide) return '';
      var img = qs('[data-main-image]', slide);
      return (img && img.getAttribute('alt')) || '';
    }

    function renderLightbox() {
      if (!lightboxImg) return;
      lightboxImg.src = mediaSrc(lightboxIndex);
      lightboxImg.alt = mediaAlt(lightboxIndex);
      if (lightboxCounter) {
        lightboxCounter.textContent = lightboxIndex + 1 + ' / ' + slides.length;
      }
      lightboxThumbs.forEach(function (thumb, n) {
        thumb.classList.toggle('is-active', n === lightboxIndex);
      });
    }

    function setLightbox(open, atIndex) {
      if (!lightbox) return;
      lightboxOpen = !!open;
      if (typeof atIndex === 'number') lightboxIndex = atIndex;
      lightbox.hidden = !lightboxOpen;
      document.body.classList.toggle('pdp-lightbox-open', lightboxOpen);
      if (lightboxOpen) {
        renderLightbox();
        var closeBtn = qs('[data-lightbox-close]', lightbox);
        if (closeBtn) closeBtn.focus();
      }
    }

    function openLightboxFromCurrent() {
      setLightbox(true, index);
    }

    if (lightbox && slides.length) {
      var trigger = qs('[data-lightbox-trigger]', gallery);
      var tapStartX = 0;
      var tapStartY = 0;
      var tapMoved = false;

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (isMobile() && tapMoved) return;
          e.preventDefault();
          openLightboxFromCurrent();
        });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openLightboxFromCurrent();
          }
        });
        trigger.addEventListener(
          'touchstart',
          function (e) {
            if (!e.touches[0]) return;
            tapStartX = e.touches[0].clientX;
            tapStartY = e.touches[0].clientY;
            tapMoved = false;
          },
          { passive: true }
        );
        trigger.addEventListener(
          'touchmove',
          function (e) {
            if (!e.touches[0]) return;
            if (
              Math.abs(e.touches[0].clientX - tapStartX) > 12 ||
              Math.abs(e.touches[0].clientY - tapStartY) > 12
            ) {
              tapMoved = true;
            }
          },
          { passive: true }
        );
      }

      qsa('[data-lightbox-close]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          setLightbox(false);
        });
      });

      var lbPrev = qs('[data-lightbox-prev]', root);
      var lbNext = qs('[data-lightbox-next]', root);
      if (lbPrev) {
        lbPrev.addEventListener('click', function (e) {
          e.stopPropagation();
          lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
          renderLightbox();
          goTo(lightboxIndex);
        });
      }
      if (lbNext) {
        lbNext.addEventListener('click', function (e) {
          e.stopPropagation();
          lightboxIndex = (lightboxIndex + 1) % slides.length;
          renderLightbox();
          goTo(lightboxIndex);
        });
      }

      lightboxThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.stopPropagation();
          lightboxIndex = Number(thumb.getAttribute('data-index')) || 0;
          renderLightbox();
          goTo(lightboxIndex);
        });
      });

      /* Swipe inside lightbox */
      var lbStage = qs('.pdp-lightbox__stage', root);
      if (lbStage && slides.length > 1) {
        var lbTouchX = 0;
        lbStage.addEventListener(
          'touchstart',
          function (e) {
            lbTouchX = e.changedTouches[0].screenX;
          },
          { passive: true }
        );
        lbStage.addEventListener(
          'touchend',
          function (e) {
            var dx = e.changedTouches[0].screenX - lbTouchX;
            if (Math.abs(dx) < 40) return;
            lightboxIndex =
              (lightboxIndex + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
            renderLightbox();
            goTo(lightboxIndex);
          },
          { passive: true }
        );
      }

      document.addEventListener('keydown', function (e) {
        if (!lightboxOpen) return;
        if (e.key === 'Escape') setLightbox(false);
        if (e.key === 'ArrowLeft') {
          lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
          renderLightbox();
          goTo(lightboxIndex);
        }
        if (e.key === 'ArrowRight') {
          lightboxIndex = (lightboxIndex + 1) % slides.length;
          renderLightbox();
          goTo(lightboxIndex);
        }
      });
    }

    syncUi();
    return { goTo: goTo, goToMediaId: goToMediaId };
  }

  function initTabs(root) {
    var tabsRoot = qs('[data-pdp-tabs]', root);
    if (!tabsRoot) return;
    var tabs = qsa('[data-tab]', tabsRoot);
    var panels = qsa('[data-panel]', tabsRoot);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-panel') === id;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
      });
    });

    /* Mobile: exclusive accordion */
    var mq = window.matchMedia('(max-width: 989px)');
    function syncAcc() {
      var details = qsa('.pdp-acc', tabsRoot);
      if (mq.matches) {
        details.forEach(function (d, i) {
          d.open = i === 0;
        });
        panels.forEach(function (panel) {
          panel.hidden = false;
          panel.classList.add('is-active');
        });
      } else {
        details.forEach(function (d) {
          d.open = true;
        });
        var activeTab = qs('.pdp-tabs__tab.is-active', tabsRoot);
        var activeId = activeTab ? activeTab.getAttribute('data-tab') : 'info';
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-panel') === activeId;
          panel.hidden = !on;
          panel.classList.toggle('is-active', on);
        });
      }
    }
    syncAcc();
    if (mq.addEventListener) mq.addEventListener('change', syncAcc);
    else if (mq.addListener) mq.addListener(syncAcc);

    qsa('.pdp-acc', tabsRoot).forEach(function (detail) {
      detail.addEventListener('toggle', function () {
        if (!mq.matches || !detail.open) return;
        qsa('.pdp-acc', tabsRoot).forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }

  function initSticky(root, getSubmitState) {
    var sticky = qs('[data-pdp-sticky]', root);
    var buybox = qs('[data-pdp-buybox]', root);
    var atc = qs('[data-pdp-atc]', root);
    var stickyAtc = qs('[data-sticky-atc]', root);
    if (!sticky || !buybox || !atc) return;

    var mq = window.matchMedia('(max-width: 989px)');
    var buyboxInView = true;
    var io = null;

    function setVisible(on) {
      var show = on && mq.matches;
      sticky.hidden = !show;
      sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('has-pdp-sticky', show);
    }

    function recompute() {
      setVisible(!buyboxInView);
    }

    function bindObserver() {
      if (io) {
        io.disconnect();
        io = null;
      }
      if (!mq.matches || !('IntersectionObserver' in window)) {
        setVisible(false);
        return;
      }
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            buyboxInView = entry.isIntersecting;
            recompute();
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0 }
      );
      io.observe(buybox);
    }

    bindObserver();
    if (mq.addEventListener) mq.addEventListener('change', bindObserver);
    else if (mq.addListener) mq.addListener(bindObserver);

    if (stickyAtc) {
      stickyAtc.addEventListener('click', function () {
        if (stickyAtc.disabled) return;
        atc.click();
      });
    }

    return {
      sync: function (variant, strings) {
        var priceEl = qs('[data-sticky-price]', sticky);
        if (priceEl && variant) {
          priceEl.textContent = formatMoney(variant.price, strings.currency);
        }
        if (stickyAtc) {
          stickyAtc.disabled = !variant || !variant.available;
          stickyAtc.textContent =
            variant && variant.available ? strings.addToCart : strings.soldOut || strings.unavailable;
        }
        var thumb = qs('[data-sticky-thumb]', sticky);
        if (thumb && variant && variant.featured_image) {
          thumb.src = variant.featured_image.src
            ? variant.featured_image.src.replace(/(\.[^.]+)(\?.*)?$/, '_96x$1$2')
            : thumb.src;
        }
      }
    };
  }

  function initSocialProof(root) {
    var wrap = qs('[data-pdp-social-proof]', root);
    if (!wrap) return;
    var items = qsa('[data-proof-item]', wrap);
    if (items.length < 2) return;
    var index = 0;

    window.setInterval(function () {
      items[index].hidden = true;
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].hidden = false;
      items[index].classList.add('is-active');
    }, 4500);
  }

  function init() {
    var root = qs('[data-main-product]');
    if (!root) return;

    var stringsEl = document.getElementById('ProductFormStrings');
    var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    var jsonEl = qs('[data-product-json]', root);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var variantInput = qs('[data-variant-id]', root);
    var form = qs('[data-product-form]', root);
    var submit = qs('[data-pdp-atc]', root);
    var skuEl = qs('[data-product-sku]', root);
    var skuWrap = qs('[data-sku-wrap]', root);
    var priceSale = qs('[data-price-sale]', root);
    var priceCompare = qs('[data-price-compare]', root);
    var priceDiscount = qs('[data-price-discount]', root);
    var live = qs('[data-price-live]', root);

    var gallery = initGallery(root);
    initTabs(root);
    initSocialProof(root);
    var sticky = initSticky(root);

    /* Qty steppers */
    var qtyInput = qs('[data-qty-input]', root);
    var minus = qs('[data-qty-minus]', root);
    var plus = qs('[data-qty-plus]', root);
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
      plus.addEventListener('click', function () {
        var v = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = v;
      });
    }

    function selectedOptions() {
      return qsa('.pdp-option', root).map(function (fieldset) {
        var checked = qs('input:checked', fieldset);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      if (!product) return null;
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return opt === options[i];
        });
      });
    }

    function optionAvailable(optionIndex, value, current) {
      if (!product) return true;
      return product.variants.some(function (variant) {
        if (variant.options[optionIndex] !== value) return false;
        return variant.options.every(function (opt, i) {
          if (i === optionIndex) return true;
          return !current[i] || opt === current[i];
        }) && variant.available;
      });
    }

    function updateOptionAvailability(current) {
      qsa('.pdp-option', root).forEach(function (fieldset, optionIndex) {
        qsa('input[data-option-value]', fieldset).forEach(function (input) {
          var available = optionAvailable(optionIndex, input.value, current);
          input.disabled = !available;
        });
      });
    }

    function updatePrice(variant) {
      if (!variant) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceSale) {
        priceSale.textContent = formatMoney(variant.price, strings.currency);
        priceSale.className = onSale ? 'pdp-price__sale' : 'pdp-price__regular';
      }
      if (priceCompare) {
        if (onSale) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(variant.compare_at_price, strings.currency);
        } else {
          priceCompare.hidden = true;
        }
      }
      if (priceDiscount) {
        if (onSale) {
          var pct = Math.round(
            ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
          );
          priceDiscount.hidden = false;
          priceDiscount.textContent = '%' + pct;
        } else {
          priceDiscount.hidden = true;
        }
      }
      if (live) {
        live.textContent = variant.available
          ? formatMoney(variant.price, strings.currency)
          : strings.soldOut || '';
      }
    }

    function updateVariant(variant) {
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;

      if (skuEl) {
        skuEl.textContent = variant.sku || '';
        if (skuWrap) skuWrap.hidden = !variant.sku;
      }

      updatePrice(variant);

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? strings.addToCart : strings.soldOut;
      }

      qsa('.pdp-option', root).forEach(function (fieldset, i) {
        var label = qs('[data-option-selected]', fieldset);
        if (label && variant.options[i]) label.textContent = variant.options[i];
      });

      var mediaId =
        (variant.featured_media && variant.featured_media.id) ||
        (variant.featured_image && variant.featured_image.id);
      if (mediaId) gallery.goToMediaId(mediaId);

      if (sticky) sticky.sync(variant, strings);

      var url = root.getAttribute('data-product-url');
      if (url && window.history && window.history.replaceState) {
        var next = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variant.id;
        window.history.replaceState({}, '', next);
      }
    }

    if (product) {
      root.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"]')) return;
        var options = selectedOptions();
        updateOptionAvailability(options);
        var variant = findVariant(options);
        if (variant) updateVariant(variant);
        else if (submit) {
          submit.disabled = true;
          submit.textContent = strings.unavailable || strings.soldOut;
        }
      });
      updateOptionAvailability(selectedOptions());
    }

    /* AJAX add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!submit || submit.disabled) return;

        var formData = new FormData(form);
        submit.disabled = true;
        var prevLabel = submit.textContent;

        fetch(window.Shopify && Shopify.routes && Shopify.routes.root
          ? Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            rebuildCartDrawer(cart);
            if (!openCartDrawer()) {
              window.location.href = '/cart';
            }
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            var variant = product ? findVariant(selectedOptions()) : null;
            if (variant) {
              submit.disabled = !variant.available;
              submit.textContent = variant.available ? strings.addToCart : strings.soldOut;
            } else {
              submit.disabled = false;
              submit.textContent = prevLabel;
            }
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
